import React, { useEffect, useState } from "react";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import SubMenuList from "../layoutComponents/SubMenuList";
import CustomSubMenuList from "./CustomSubMenuList";

const styles = {
  container: (isMobile, centerWidth) => ({
    marginTop: "60px",
    height: "calc(100% - 57px)",//isMobile ? 0 : "calc(100% - 64px)",
    width: isMobile ? "100%" : centerWidth ? "230px" : 291.47,
    minWidth: isMobile ? "100%" : centerWidth ? centerWidth : 270,
    // marginTop: isMobile ? 0 : 64,
    position: "relative",
    borderRight: centerWidth && "1px solid #dae0e5",
  }),
  fab: { position: "absolute", bottom: 16, right: 16,color:"white" },
};

function SubMenuLayout(props) {
  const [loading, setloading] = useState(false);
  const fabHandler = (e) => {
    e.preventDefault();
    if (props.setOpen) props.setOpen(false);
    props.fabClickHandler();
  };
  useEffect(() => {
    setloading(props.loading ? props.loading : false);
  }, [props.loading]);

  return (
    <div style={styles.container(props.isMobile, props.centerWidth)}>
      {console.log(props,"propsList", ["/PurchaseOrders",].includes(window.location.pathname) )}
        {["/PurchaseOrders", "/Brokers", "/Millers", "/Transporters"].some((p) => window.location.pathname.startsWith(p))
          ? <CustomSubMenuList {...props} />
          :<>
        <SubMenuList {...props} />
        {console.log(props.tabs[0].widget,"widget__")}
      {props.tabs && props.fabClickHandler ? (
        loading === true ? (
          ""
        ) :  props.tabs[0].widget!==null&&props.tabs[0].widget?.has_create_permission&&(
          <Fab style={styles.fab} color="primary" aria-label="add" size="medium" onClick={fabHandler}>
            <AddIcon />
          </Fab>
        )
      ) : (
        ""
      )}
      </>
      }
    </div>
   
  );
}

export default SubMenuLayout;
